import React from "react";
import Header from "./components/Header";
import Hero from "./components/hero";

function App() {
  return (
   <>
     <Header/>
     <Hero/>
  </>
  );
}

export default App;
